
var jQuery = require("jquery");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

$(document).on("turbolinks:load", function() {
  
  // on click of the dummy buttons triggers the real input file
  $('#videoPicture').on('click', function(){
    $("#file-input").click();
  });

  $('#videoPicture').on('dragover', false).on('drop', function(e){
    e.preventDefault();  
    e.stopPropagation();
    let fileInputElement = document.getElementById('file-input');

    if (e.originalEvent.dataTransfer.files.length == 1 ){
      fileInputElement.files = e.originalEvent.dataTransfer.files;
    }
    $("#file-input").change();
  });

  $('.input-dummy').on('click', function(){
    $(this).next("input").click();
  });
  
  // on change of the real input file, changes the dummy source
  $('.input-real').on('change', function(event){
    if(event.target.files[0])
    {
      $(this).prev('.input-dummy').attr('src', URL.createObjectURL(event.target.files[0]));
      $('.centered').addClass('d-none');      
    }
    else
    {
      $(this).prev('.input-dummy').attr('src', $('.dummyImg').attr('osrc'));
      $('.centered').removeClass('d-none');
    }
  });


  ///********** STREAMS  **********/
  
  // display save and cancel buttons
  $('.form-control-save').on('focus', function(){
    //$('.input-save').addClass('d-none');
    $(this).siblings('.input-save').removeClass('d-none');
    $(this).siblings('.separator').removeClass('d-none');
  });
  
  // hide save and cancel buttons
  $(document).on('focus', '.multi-select', function(){
    $(this).siblings('.input-save').removeClass('d-none');
    $('#selectedCategories').find('.closeButton').removeClass('d-none');
  });

  // hide categories delete button
  $(document).on('click', '.multiSelectButtons', function(){
    $('#selectedCategories').find('.closeButton').addClass('d-none');
  });

  // every input cancel
  $('.input-save-cancel').on('click', function(){
    let save_input = $(this).parents('.form-floating').find('.form-control-save');
    save_input.val($(save_input).data('value')); 
    $(this).parent('.input-save').addClass('d-none');
    $(this).parent().next('.separator').addClass('d-none');
    let multi_select = $(this).parents('.form-floating').find('.multi-select');
    if (multi_select.length > 0 ){
      let select = document.getElementsByClassName('multi-select')[0];
      let control = select.tomselect;
      console.log(multi_select.data("value"));
      control.clear();
      multi_select.data("value").split(",").forEach(function (item) {
        control.addItem(item);
      });
    }
  });
  
  // every input save
  $('.input-save .btn-main').on('click', function(){
    $(this).parent('.input-save').addClass('d-none');
    $(this).parent().next('.separator').addClass('d-none');
    let save_input = $(this).parents('.form-floating').find('.form-control-save');
    save_input.data('value', $(save_input).val()); 
  });

  // Show copy icon on hover over Embeber div
  $('.embeber-div').hover(function(){
    $(this).find('#copy-icon').removeClass('d-none');
  },function(){
    $(this).find('#copy-icon').addClass('d-none');
  });

  function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
  }

  $("#copy-icon").click(function () {
    var element = $(this).attr("data");
    copyToClipboard($('.' + element));
  });

    // Loading the categories in the stream/video when the page loads

  $(document).ready(function(){
    $("#selectedCategories").empty();
    var $data = []
    if ($('#multiSelect').val())
    {
      $data = $('#multiSelect').val().split(',');
      for (var i = 0; i < $data.length; i++) {
        if($data[i] != '')
        {
          $( "#selectedCategories" ).append('<label class="publish-btn btn btn-block category-main me-2 px-3" for="category">'
          + $data[i] +'<button type="button" class="closeButton close d-none" data-id="'
          + $data[i] +'" id="'+ $data[i] +'" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></span></label>');
        }    
      }
    }
  });
  
    // Loading the categories when the user is making updates
  
  $('#multiSelect').on('change', function(){
    $("#selectedCategories").empty();
    var $data = []
    $data = $('#multiSelect').val().split(',');
    for (var i = 0; i < $data.length; i++) {
      if($data[i] != '')
      {
        $( "#selectedCategories" ).append('<label class="publish-btn btn btn-block category-main me-2 px-3" for="category">'
        + $data[i] +'<button type="button" class="closeButton close" data-id="'
        + $data[i] +'" id="'+ $data[i] +'" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></span></label>');
      }
    }
  })

  // Set the eye icon on the stream publish/ hide button
  $('.publish-btn').on('click', function(){
    $('.publish-btn').addClass('d-none');
    $('.hide-stream-label').removeClass('d-none');
    /*setTimeout(function() {
      $('.publish-btn').toggleClass('d-none');
      if ($('.publish-vale').val() == "1"){
        $('.publish-vale').val("0");
      }
      else{
        $('.publish-vale').val("1");
      }
    },100);*/
  });


   ///********** USERS  **********/

  // When edit button is clicked, all the inputs become enabled for editing and change the button to the save button
  $('.editUserButton').on('click', function(){
    $("#clientForm input[type=text]").each(function () {
      $(this).prop('disabled', false);
      $(this).addClass('entity-input');
    });
    $('.input-dummy-entity').removeClass('pe-none');
    $('.entity').addClass('entity-shadow');
    $("#clientImageInput").prop('disabled', false);
    $('.saveUserButton').removeClass('d-none');
    $('.editUserButton').addClass('d-none');
  });

  // When save button is clicked change the button to the edit button
  $('.saveUserButton').on('click', function(){
    $('.saveUserButton').addClass('d-none');
    $('.editUserButton').removeClass('d-none');
    $('.entity').removeClass('entity-shadow');
    $('.input-dummy-entity').addClass('pe-none');
    $("#clientForm input[type=text]").each(function () {
      $(this).removeClass('entity-input');
    });
  });
  
  $(document).on('click', '.closeButton', function(){
    let select = document.getElementsByClassName('multi-select')[0];
    let control = select.tomselect;
    control.removeItem($(this).data('id'), false)
  });
    
  
  
  ///********** ENTITY AND USERS  **********/

  // on click of the dummy buttons triggers the real input file
  $('.input-dummy-entity').on('click', function(){
    $(this).next("input").click();
  });
  
  // on change of the real input file, changes the dummy source
  $('.input-real-entity').on('change', function(event){
    if(event.target.files[0])
    {
      $(this).prev('.input-dummy-entity').attr('src', URL.createObjectURL(event.target.files[0]));      
    }
    else
    {
      $(this).prev('.input-dummy-entity').attr('src', $('.dummyEntityImg').attr('osrc'));
    }
  });

  $('.entity').hover(function(){
    if($(this).hasClass('entity-shadow'))
    {
      $('.overlay_1').removeClass('d-none');      
    }
  }, function(){
    $('.overlay_1').addClass('d-none');
  });
  

  $('.overlay-entity').on('click', function(){
    $(this).prev('#clientImageInput').click();
  });

  ///********** VIDEOS  **********/

  $('.document').ready(function(){
    var url = window.location.href;
    if(url.indexOf("?unpublished") > -1)
    {
      $(".published").removeClass('active');
      $(".tabcontent.unpublished").removeClass('d-none');
      $(".tabcontent.published").addClass('d-none');
      $(".unpublish-tab-content").addClass('active');
    }
  });

  $('.publish-video-btn').on('click', function(){
    $('.video-publish').val("1");
  });


  //Truncate Tool Function

  function truncateString(str, length) {
      return str.length > length ? str.substring(0, length - 3) + '...' : str
  }

  $('#file-input').on('change', function(){
    var fileInput = document.getElementById('file-input');
    if(fileInput.files[0])
    {
      var title = fileInput.files[0].name;
      $('.instructionsLabel').text(truncateString(title, 50));     
    }
    else
    {
      $('.instructionsLabel').text($('.instructionsLabel').data('instructions'));
    }
  });

  var uploadingFiles = 0;

  // UPLOAD VIDEOS PROGRESS BAR
  $(document).off('submit', '#video-upload-form.new');
  $(document).on('submit', '#video-upload-form.new', function(e){
    e.preventDefault();

    var videoTitle = ($(this).find('#floatingTitle').val().length > 20) ? $(this).find('#floatingTitle').val().substring(0, 20) + "..." : $(this).find('#floatingTitle').val();
    $('.videoLabel').text(videoTitle);
    $('#addVideoModal').modal('hide');

    uploadingFiles += 1;
    var formData = new FormData();
    var fileInput = document.getElementById('file-input');
    formData.append('file', fileInput.files[0] );
    formData.append('title', $(this).find('#floatingTitle').val());
    formData.append('description', $(this).find('#floatingDescription').val());
    formData.append('video_date', $(this).find('#floatingVideoDate').val());
    formData.append('categories', $(this).find('#multiSelect').val());
    formData.append('publish', $(this).find('.video-publish').val());
    
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      // Process our return data
      if (xhr.status >= 200 && xhr.status < 300) {
        // Runs when the request is successful
        var jsonResponse = JSON.parse(xhr.responseText);
        if(jsonResponse.video.published_at == null){
          $(".video-link").attr("href", '/admin/videos?video=' + jsonResponse.video.id + "?unpublished");
          $(".video-link").removeClass('d-none');
        }
        else{
          $(".video-link").attr("href", '/admin/videos?video=' + jsonResponse.video.id);
          $(".video-link").removeClass('d-none');
        }
      } else {
        // Runs when it's not
        $('.confirmIcon').addClass('d-none');
        $('.uploadedLabel').addClass('d-none');

        // show alert

        $('body').append('<div class="alert alert-danger" role="alert">\
          <span class="close-alert position-absolute fs-4 end-0 me-2" role="button" aria-hidden="true">&times;</span>\
          <strong>Erro</strong><br>\
          ' + JSON.parse(xhr.responseText).error + '\
        </div>')
        
        console.log(JSON.parse(xhr.responseText));
      }
    
    };
    xhr.open('POST', '/admin/videos', true);

    // Set up a callback function to handle the response
    xhr.upload.onprogress = e => {
      $('.progress-bar-container').removeClass('d-none').addClass('d-inline-block');
      if (e.lengthComputable) {
        $('.uploadedLabel').addClass('d-none');
        $('.uploadingLabel').removeClass('d-none');
        $('.progress-bar-container .progress-bar').removeClass('d-none');
        $('.confirmIcon').addClass('d-none');
        $(".add-video-btn").addClass("locked").attr('title', 'Por favor espere o carregamento terminar.').attr("data-bs-target", "").tooltip();

        const percentComplete = (e.loaded / e.total) * 100;
        console.log(`${percentComplete}% completo`);
        $('#progress').css('width', `${percentComplete}%`);
      }
      if (e.loaded == e.total)
      {
        uploadingFiles -= 1;
        if(uploadingFiles <= 0){
          $('.progress-bar-container .progress-bar').addClass('d-none');
          $(".errorLabel").addClass('d-none');
          $('.confirmIcon').removeClass('d-none');
          $('.uploadedLabel').removeClass('d-none');
          $('.uploadingLabel').addClass('d-none');
          $('.videoLabel').addClass('d-none');
          $(".add-video-btn").removeClass("locked").attr('title', '').attr("data-bs-target", "#addVideoModal").tooltip();
        }
      }
    };
    // Convert the data to JSON and send the request
    xhr.send(formData);
  });


  // show message when the users tries to leave
  $(window).on('beforeunload', function() {
    if (uploadingFiles > 0) return "Do you really want to close?"; // null will allow exit without a question
  });


  $('.ajax_video_remote_update .save-btn').on('click', function(){
    var parent = $(this).parents('.ajax_video_remote_update');
    var id = $(parent).data("id");
    var input = parent.find('.form-control-save');
    var value = input.val();
    var name = input.prop('name');
    var xhr = new XMLHttpRequest();
    input.removeClass('error-border');

    if (name == "stream[status]"){
      $(this).attr('disabled', true).text("A parar...");
    }

    xhr.onreadystatechange = function(request) {
      if (request.currentTarget.status == 400 || request.currentTarget.status == 500) {
        var jsonResponse = JSON.parse(this.response);
        $('#errorModal .error-text').text(jsonResponse.errors.title.message);
        $('#errorModal').modal('show');
        input.addClass('error-border');
      }
      if (request.currentTarget.status == 200 && name == "stream[status]"){
        window.location = '/admin/streams/';
      }

    };
    xhr.open('PATCH', '/admin/streams/' + id, true);
    var formData = new FormData();
    formData.append(name, value);
    xhr.send(formData);
  });
});

